import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import img from "../../images/my-banner.png"
import "./Header.css"

const Header = () => {
    return (
        <div>
            <Container className="py-5">
                <Row>
                    <Col sm={12} md={6} lg={6}>
                        <h2 className="fw-bold"> I am Sujan Chandar Majumder</h2>
                        <p>I am a Web Developer located in Feni,Chittagong, Bangladesh. I currently work as a part time Remote Junior Web Developer for Online Market. I am looking to take on more work and to increase my skills as a Web Developer.</p>
                        <p><strong>Phone : </strong> +8801837039532</p>
                        <p><strong>Email : </strong>sujanmamjumder211@gmail.com</p>
                        <p><strong>Address : </strong> Debipur, Feni, Bangladesh</p>
                        <p><strong>Social : </strong>
                            <a href="https://www.facebook.com/sujanmajumderfeni/" target="_blank"> <i className="fab fa-facebook"></i> </a>
                            <a href="https://www.linkedin.com/in/developer-sujan-majumder/" target="_blank"> <i className="fab fa-linkedin"></i> </a>
                            <a href="https://twitter.com/sujanma19612482"> <i className="fab fa-twitter" target="_blank"></i> </a>
                            <a href="https://github.com/sk211/"> <i className="fab fa-github" target="_blank"></i> </a>
                        </p>

                        <Link to="#contact" className="btn btn-info " style={{ marginRight: "10px" }}>Here me</Link>
                        <Link to="/SUJAN CHANDRA MAJUMDER.pdf" className="btn btn-primary " target="_blank" download>Download CV</Link>


                    </Col>
                    <Col sm={12} md={6} lg={6} id="header_img">
                        <img src={img} alt="my_image" width="400" />
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Header;
